import { FormHelperText, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { StyledTextField } from "../../TextField/TextField";

export default function WorkableAPISection(props) {
  const useStyles = makeStyles((theme) => ({
    error: {
      color: theme.palette.error.main,
    },
    textField: {
      "& .Mui-error": {
        color: theme.palette.error.main,
      },
      "& .MuiFormHelperText-root": {
        color: theme.palette.error.main,
      },
      "& .MuiInput-underline.Mui-error:after": {
        borderBottomColor: theme.palette.error.main,
      },
    },
  }));

  const classes = useStyles();
  return (
    <>
      <Grid item xs={12} sm={4}>
        <StyledTextField
          InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
          label="Token"
          value={props.token}
          error={props.showInputError && props.token === ""}
          className={classes.textField}
          variant="standard"
          fullWidth
          required
          onChange={(e) => props.setToken(e.target.value)}
        />
        {props.showInputError && props.token === "" && (
          <FormHelperText className={classes.error}>Token Required</FormHelperText>
        )}
      </Grid>
      <Grid item xs={12} sm={4}>
        <StyledTextField
          InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
          label="Additional Properties"
          value={props.additonalProperties}
          variant="standard"
          fullWidth
          onChange={(e) => props.setAdditonalProperties(e.target.value)}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <StyledTextField
          InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
          label="Requisition Statuses"
          value={props.requisitionStatuses}
          error={props.showInputError && props.requisitionStatuses === ""}
          className={classes.textField}
          variant="standard"
          fullWidth
          required
          onChange={(e) => props.setRequisitionStatuses(e.target.value)}
        />
        {props.showInputError && props.requisitionStatuses === "" && (
          <FormHelperText className={classes.error}>Statuses Required</FormHelperText>
        )}
      </Grid>
    </>
  );
}
